// Calificación de conducción de HOY para la tarjeta de la unidad (en Mapon,
// pestaña «Ahora»). Mismo cálculo que el informe «Comportamiento del
// conductor» (historial del día + scoreDriving + ajustes de la compañía), así
// que la tarjeta y el informe nunca dan números distintos.
//
// shortcut: un día de una unidad se califica en el navegador con sus puntos
// crudos; si la tarjeta llega a mostrarlo para muchas unidades a la vez, pasar a
// la calificación precalculada en daily_unit_summaries (fase 2).
import { useQuery } from "@tanstack/react-query";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import { buildWindows, loadDeviceHistory } from "../../pages/reports/utils/trackingHistoryWindows";
import { DEFAULT_SETTINGS, scoreDriving } from "../../pages/reports/utils/drivingScore";
import { fetchScoreSettings } from "../../pages/reports/utils/scoreSettingsApi";

export const startOfToday = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};

export function useTodayDrivingScore(deviceId: string, enabled: boolean) {
  const companyId = useCompaniesStore((s) => s.companyId);
  const settingsQ = useQuery({
    queryKey: ["driving-score-settings", companyId],
    queryFn: () => fetchScoreSettings(companyId!),
    enabled: enabled && !!companyId,
    staleTime: 10 * 60_000,
  });
  // Si los ajustes fallan, se califica con los de por omisión (como el informe sin API).
  const settings = settingsQ.data?.settings ?? (settingsQ.isError ? DEFAULT_SETTINGS : undefined);
  const from = startOfToday();

  return useQuery({
    queryKey: ["driving-score-today", deviceId, from, settings],
    queryFn: async () => {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const { points } = await loadDeviceHistory(deviceId, buildWindows(from, Date.now()), tz);
      return scoreDriving(points, settings!);
    },
    enabled: enabled && !!settings,
    staleTime: 5 * 60_000,
  });
}
